import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setMode } from '../store/appSlice';
import { AppMode } from '../types';

interface ModeSelectorProps {
  /** Return false to cancel the mode change. */
  beforeChange?: (next: AppMode) => boolean;
}

const ModeSelector: React.FC<ModeSelectorProps> = ({ beforeChange }) => {
  const dispatch = useAppDispatch();
  const currentMode = useAppSelector((state) => state.app.mode);

  const handleModeChange = (mode: AppMode) => {
    if (mode === currentMode) return;
    if (beforeChange && !beforeChange(mode)) return;
    dispatch(setMode(mode));
  };

  return (
    <div className="mb-4">
      <ButtonGroup className="d-flex flex-wrap w-100">
        <Button
          variant={currentMode === 'backingTrack' ? 'primary' : 'outline-primary'}
          onClick={() => handleModeChange('backingTrack')}
          className="flex-grow-1"
        >
          Backing Tracks
        </Button>
        <Button
          variant={currentMode === 'metronome' ? 'primary' : 'outline-primary'}
          onClick={() => handleModeChange('metronome')}
          className="flex-grow-1"
        >
          Metronome
        </Button>
        <Button
          variant={currentMode === 'tracks' ? 'primary' : 'outline-primary'}
          onClick={() => handleModeChange('tracks')}
          className="flex-grow-1"
        >
          Tracks Editor
        </Button>
        <Button
          variant={currentMode === 'stats' ? 'primary' : 'outline-primary'}
          onClick={() => handleModeChange('stats')}
          className="flex-grow-1"
        >
          Stats
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default ModeSelector;
